export default __webpack_public_path__ + "static/media/bg.0000abe4.png";